import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-white/10 bg-[#05070B]">
            <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-16 pb-8">
                <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
                    <div>
                        <p className="f-display text-2xl font-black tracking-tight text-white">
                            VIVEK<span className="text-[#FF5500]">.</span>
                            <span className="ml-2 f-mono text-[10px] uppercase tracking-[0.28em] text-slate-500">
                                Coaching Centre
                            </span>
                        </p>
                        <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
                            Learning that moves you ahead. Expert coaching for
                            Classes 6-12, JEE &amp; NEET foundation, and
                            competitive exams.
                        </p>
                        <div className="mt-6 flex flex-col gap-3">
                            <a
                                href="tel:+916207984279"
                                data-testid="footer-phone-link"
                                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-[#FF5500] transition-colors w-fit"
                            >
                                <Phone size={15} className="text-[#FF5500]" />
                                +91 6207984279
                            </a>
                            <a
                                href="mailto:zyne6431@gmail.com"
                                data-testid="footer-email-link"
                                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-[#FF5500] transition-colors w-fit"
                            >
                                <Mail size={15} className="text-[#FF5500]" />
                                zyne6431@gmail.com
                            </a>
                        </div>
                    </div>

                    <div>
                        <p className="f-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Explore
                        </p>
                        <ul className="mt-4 space-y-2.5">
                            <li><Link to="/" data-testid="footer-link-home" className="text-sm text-slate-300 hover:text-white transition-colors">Home</Link></li>
                            <li><Link to="/about" data-testid="footer-link-about" className="text-sm text-slate-300 hover:text-white transition-colors">About Us</Link></li>
                            <li><Link to="/contact" data-testid="footer-link-contact" className="text-sm text-slate-300 hover:text-white transition-colors">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div>
                        <p className="f-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Legal
                        </p>
                        <ul className="mt-4 space-y-2.5">
                            <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-slate-300 hover:text-white transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/disclaimer" data-testid="footer-link-disclaimer" className="text-sm text-slate-300 hover:text-white transition-colors">Disclaimer</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 overflow-hidden select-none" aria-hidden="true">
                    <p className="wordmark text-[18vw] md:text-[11rem] uppercase">
                        VIVEK
                    </p>
                </div>

                <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/5 pt-6">
                    <p className="f-mono text-[11px] text-slate-500">
                        © {year} Vivek Coaching Centre. All rights reserved.
                    </p>
                    <p className="f-mono text-[11px] text-slate-600">
                        Education · Discipline · Distinction
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
